import { GregorioGlyph } from '../structures/GregorioGlyph';
import { GregorioGlyphType } from '../enums/GregorioGlyphType';
import { GregorioLiquescentia, TAIL_LIQUESCENTIA_MASK } from '../enums/GregorioLiquescentia';
import { GregorioNoteElement } from '../structures/GregorioNoteElement';
import { add_note_to_a_glyph } from './add_note_to_a_glyph';
import { close_normal_glyph } from './close_normal_glyph';


export function close_fusion_glyph(
  glyphs: GregorioGlyph[],
  notes: GregorioNoteElement[],
  first_note: number,
  orig_liquescentia: GregorioLiquescentia,
) {
  let first = true;
  let prev_shift = 0, shift, shift2;
  let liquescentia = orig_liquescentia;

  const last_note = notes.length - 1;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    let processed = false;

    if (first_note === last_note) {
      close_fused_glyph(
        glyphs,
        notes,
        GregorioGlyphType.PUNCTUM,
        first_note,
        last_note,
        liquescentia & ~TAIL_LIQUESCENTIA_MASK);

      return notes[last_note];
    }

    const next = first_note + 1;

    shift = notes[next].pitch - notes[first_note].pitch;
    if (shift !== 0 && next === last_note) {
      /* there are exactly two notes left, so we end fusion */
      return close_fused_glyph(
        glyphs,
        notes,
        shift < 0 ? GregorioGlyphType.FLEXA : GregorioGlyphType.PODATUS,
        first_note,
        last_note,
        liquescentia);
    }

    if (prev_shift >= 0 && shift < 0) {
      /* check for a porrectus-like flexus */
      const next_next = next + 1;
      shift2 = notes[next_next].pitch - notes[next].pitch;
      if (shift2 > 0) {
        if (next_next == last_note) {
          /* there are exactly three notes left in a porrectus shape,
           * so we end fusion */
          return close_fused_glyph(
            glyphs,
            notes,
            GregorioGlyphType.PORRECTUS,
            first_note,
            last_note,
            liquescentia);
        }
        /* found a porrectus-like flexus */
        // add_intervening_texverbs(last_glyph, first_note, next);
        close_fused_glyph(
          glyphs,
          notes,
          shift < 0 ? GregorioGlyphType.FLEXA : GregorioGlyphType.PODATUS,
          first_note,
          next,
          liquescentia & ~TAIL_LIQUESCENTIA_MASK);
          
        prev_shift = shift2;
        processed = true;
      }
    }

    if (!processed) {
      /* didn't find anything interesting, so fuse the single note */
      const result = add_note_to_a_glyph(
        GregorioGlyphType.UNDETERMINED,
        notes[first_note].pitch,
        0,
        notes[first_note].shape,
        notes[first_note].liquescentia,
        notes[first_note]);

      const next_glyph_type: GregorioGlyphType = result.next_glyph_type;

      close_fused_glyph(
        glyphs,
        notes,
        next_glyph_type,
        first_note,
        first_note,
        liquescentia & ~TAIL_LIQUESCENTIA_MASK,
      );
      prev_shift = shift;
      // eslint-disable-next-line no-param-reassign
      first_note++;
    }

    if (first) {
      first = false;
      liquescentia = (liquescentia & TAIL_LIQUESCENTIA_MASK) | GregorioLiquescentia.FUSED;
    }
  }
}

function close_fused_glyph(
  glyphs: GregorioGlyph[],
  notes: GregorioNoteElement[],
  glyph_type: GregorioGlyphType,
  first_note: number,
  current_note: number,
  liquescentia: GregorioLiquescentia,
) {
  notes[first_note].liquescentia |= (liquescentia & GregorioLiquescentia.FUSED);

  close_normal_glyph(
    glyphs,
    notes,
    glyph_type,
    first_note,
    liquescentia,
    current_note);
}
